import React from 'react';
import { Card } from '@/components/ui';
import type { SystemActivity } from '../../types/dashboard.types';

interface SystemActivityWidgetProps {
  activities: SystemActivity[];
}

export function SystemActivityWidget({ activities }: SystemActivityWidgetProps) {
  return (
    <Card className="p-6 border-slate-100 shadow-sm flex flex-col h-[320px]">
      <div className="flex items-center justify-between mb-6">
        <h3 className="font-medium text-slate-900">Hoạt động hệ thống</h3>
        <button className="sm:text-sm text-xs font-medium text-emerald-600 hover:text-emerald-700">Xem tất cả</button>
      </div>

      <div className="flex-1 flex flex-col gap-4 overflow-y-auto pr-1">
        {activities.map((item, index) => (
          <div key={index} className="flex items-center justify-between py-2 border-b border-slate-50 last:border-0">
            <div className="flex items-center gap-3">
              <i className={`${item.icon} ${item.color} text-lg`} />
              <span className="text-sm font-medium text-slate-600">{item.label}</span>
            </div>
            <span className="text-sm font-medium text-slate-900">{item.value}</span>
          </div>
        ))}
      </div>
    </Card>
  );
}
